import type { Breadcrumb, ErrorEvent } from '@sentry/browser';

const SHARE_CODE = /\/p\/[A-Za-z0-9]{10}(?=[/?#]|$)/g;
const TOKEN_PARAM = /([?&](?:token|access_token)=)[^&#]*/g;

/** Strips reusable credentials (`/p/<code>`, `token=`) from a URL sent to Sentry. */
export function scrubUrl(url: string): string {
    return url.replace(SHARE_CODE, '/p/[code]').replace(TOKEN_PARAM, '$1[token]');
}

const BREADCRUMB_URL_KEYS = ['url', 'from', 'to'];

export function scrubBreadcrumb(crumb: Breadcrumb): Breadcrumb {
    for (const key of BREADCRUMB_URL_KEYS) {
        const v = crumb.data?.[key];
        if (crumb.data && typeof v === 'string') crumb.data[key] = scrubUrl(v);
    }
    return crumb;
}

export function scrubEvent(event: ErrorEvent): ErrorEvent {
    if (event.request?.url) event.request.url = scrubUrl(event.request.url);
    event.breadcrumbs?.forEach(scrubBreadcrumb);
    return event;
}
